import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Panel } from '@layout';
import { Button } from '@atoms';
import { PageTemplate, CreateTranscriptForm } from '@templates';
import messages from './messages';

export default class TranscriptCreationPage extends PureComponent {
  static propTypes = {
    isSubmitting: PropTypes.bool,
    setField: PropTypes.func.isRequired,
    createTranscript: PropTypes.func.isRequired,
    isTranscriptNeeded: PropTypes.bool.isRequired,
    isAITranscriptNeeded: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isSubmitting: false,
  };

  createTranscript = () => !this.props.isSubmitting && this.props.createTranscript(false);

  render() {
    const { isSubmitting, isTranscriptNeeded, isAITranscriptNeeded } = this.props;
    const canCreateTranscript = isTranscriptNeeded || isAITranscriptNeeded;
    return (
      <PageTemplate title={<FormattedMessage {...messages.title} />}>
        <Panel>
          <CreateTranscriptForm />
          <Button
            disabled={!canCreateTranscript}
            onClick={this.createTranscript}
            loading={isSubmitting}
            id="create-button"
            primary
          >
            <FormattedMessage {...messages.create} />
          </Button>
        </Panel>
      </PageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/TranscriptCreationPage/TranscriptCreationPage.js